import { hasWindow } from './hasWindow';
export const optionMutationMap: Map<Node, () => void> = new Map();

const optionObserver =
  hasWindow &&
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // TODO: find better way to identify correct node
      optionMutationMap.get(mutation.target.parentElement.parentElement)?.();
    });
  });

export const observeOptions = <T extends HTMLElement>(node: T, callback: () => void): void => {
  // node might not be defined in connectedCallback
  if (node) {
    optionMutationMap.set(node, callback);
    optionObserver.observe(node, {
      characterData: true,
      subtree: true,
    });
  }
};

export const unobserveOptions = <T extends HTMLElement>(node: T): void => {
  optionMutationMap.delete(node);
};
